import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  fetchQueueStatus: localStorage.getItem('@innovationbrindes-crm/fetchQueueStatus-v1')
    ? JSON.parse(localStorage.getItem('@innovationbrindes-crm/fetchQueueStatus-v1'))
    : false,
}

const fetchQueueStatus = createSlice({
  name: '@innovationbrindes-crm/fetchQueueStatus-v1',
  initialState,
  reducers: {
    startQueueFetch: (state) => {
      state.fetchQueueStatus = true
      localStorage.setItem('@innovationbrindes-crm/fetchQueueStatus-v1', JSON.stringify(state.fetchQueueStatus))
    },
    pauseQueueFetch: (state) => {
      state.fetchQueueStatus = false
      localStorage.setItem('@innovationbrindes-crm/fetchQueueStatus-v1', JSON.stringify(state.fetchQueueStatus))
    },
  },
})

export const { startQueueFetch, pauseQueueFetch } = fetchQueueStatus.actions
export const selectQueueStatus = (state) => state.fetchStatusQueue
export default fetchQueueStatus.reducer
